export default __webpack_public_path__ + "alberta-add-to-outlook.633c208783db7c1dcb9d.svg";